import React from 'react'
import {Header, Footer, Sologon, ZkCloudHeader, ZkCloudFooter, ZkCloudSologon} from './signCmp'
import SignIn from './signIn'
import SignUp from './signUp'
import FindPass from "./findPass";
import Util from "../public/utils";

const SignType = {
    login: 'login',
    register: 'register',
    findPass: 'findPass'
};

class Signflow extends React.Component {

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentDidMount() {
        let target = Util.getUrlArg("target");
        if (target) {
            this.setState({target: target});
        }
    }

    getSingFlow(type) {
        switch (type) {
            case SignType.login:
                return <SignIn subAction={this.props.subAction}/>;
            case SignType.register:
                return <SignUp/>;
            case SignType.findPass:
                return <FindPass/>;
            default:
                return ''
        }
    }

    render() {
        console.log(1,'dsfsdfdsfds')
        return (
            <div className='qy-signflow'>
                <Header/>
                <div className='qy-signflow-form'>
                    <Sologon/>
                    <div className='qy-signflow-form-right'>
                        {
                            this.getSingFlow(this.props.type)
                        }
                    </div>
                </div>
                <Footer/>
            </div>
        )
    }
}

export default Signflow